import apiClient from '../axios';

export const SHOPS_API = {
    ENDPOINTS: {
        FETCH_SHOP_DETAILS: 'v1/admin/shop-details',
        UPDATE_SHOP: 'v1/admin/update-shop'
    },

    /**
     * Fetch shop details
     * @param {number} shopId - ID of the shop
     * @returns {Promise<Object>} Shop details
     */
    async fetchShopDetailsApi(shopId) {
        try {
            const authToken = localStorage.getItem('auth_token');
            if (!authToken) {
                throw new Error('No authentication token found');
            }

            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };

            const response = await apiClient.get(
                `${this.ENDPOINTS.FETCH_SHOP_DETAILS}/${shopId}`,
                config
            );

            return response.data;
        } catch (error) {
            console.error('[SHOPS_API] Error fetching shop details:', error);
            throw error;
        }
    },

    /**
     * Update shop information with optional image
     * @param {Object|FormData} shopData - Shop data to update
     * @returns {Promise<Object>} Update response
     */
    async updateShopApi(shopData) {
        const shopId = shopData.shop_id || (shopData.get && shopData.get('shop_id'));
        if (!shopId) throw new Error('Shop ID is required');

        const authToken = localStorage.getItem('auth_token');
        if (!authToken) throw new Error('No authentication token found');

        try {
            let config;
            let data;
            let url = `${this.ENDPOINTS.UPDATE_SHOP}/${shopId}`;

            // Check if we're dealing with FormData (has image)
            if (shopData instanceof FormData) {
                config = {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                    timeout: 30000,
                };
                data = shopData;
            } else {
                config = {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        'Content-Type': 'application/json',
                    },
                    timeout: 30000,
                };
                data = shopData;
            }

            const response = await apiClient.post(url, data, config);
            return response.data;
        } catch (error) {
            console.error('[SHOPS_API] Error updating shop:', error);
            const enhancedError = new Error(
                error.response?.data?.message ||
                error.message ||
                'Failed to update shop'
            );
            enhancedError.response = error.response;
            enhancedError.status = error.response?.status;
            throw enhancedError;
        }
    }
};